module.exports = "./img/28173cf2ab8264e66d6e34fd9f47707f.jpg";